
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/android",
      function () {
        return require("private-next-pages/docs/link/android/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/android"])
      });
    }
  